// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XrOdD{position:relative;display:flex;flex-direction:column}.H3n_a{font-family:"Lufga-Regular";font-weight:400;font-size:var(--font-size-p2, 12px);line-height:var(--line-height-p2, 16px);letter-spacing:.02em;margin-block-end:8px;color:#9393b1}.XDqyo{position:relative;display:flex;align-items:center}.XDqyo .MuiPickersOutlinedInput-notchedOutline{border:0}.XDqyo .MuiPickersOutlinedInput-root{block-size:46px;background:#fcfcfd;border-radius:4px;box-shadow:inset 0 0 0 1px #282863;transition:box-shadow 100ms ease}.XDqyo .MuiPickersOutlinedInput-root:hover{box-shadow:inset 0 0 0 2px #282863}.XDqyo .MuiPickersOutlinedInput-root.Mui-focused{box-shadow:inset 0 0 0 1px #6942f8}.XDqyo .MuiPickersOutlinedInput-root.Mui-disabled{box-shadow:inset 0 0 0 1px #d4d4e0}.XDqyo .MuiPickersSectionList-root{font-family:"Lufga-Regular";font-weight:400;font-size:var(--font-size-p1, 14px);line-height:var(--line-height-p1, 22px);letter-spacing:.015em;padding-inline-start:16px;color:#282863}.XDqyo .MuiPickersSectionList-sectionContent:focus{background:#e1d9fe;border-radius:3px;outline:none}.XDqyo .MuiInputLabel-root{font-family:"Lufga-Regular";font-weight:400;font-size:var(--font-size-p3, 10px);line-height:var(--line-height-p3, 14px);letter-spacing:.02em;color:#696992;padding-inline:4px;background:#fcfcfd}.XDqyo .MuiInputLabel-root.Mui-focused{color:#6942f8}.XDqyo.Cod_o .MuiPickersOutlinedInput-root,.XDqyo.Cod_o .MuiPickersOutlinedInput-root:hover{box-shadow:inset 0 0 0 1px #dd4c4c}.XDqyo.Cod_o .MuiInputLabel-root{color:#dd4c4c}.xYZC4{position:absolute;inset-inline-end:8px;display:inline-flex;align-items:center;justify-content:center;inline-size:32px;block-size:32px;border:0;padding:0;background:transparent;border-radius:999px;cursor:pointer;color:#696992}.xYZC4:hover{background:#f4f4f7}.xYZC4:disabled{cursor:default;opacity:.4}.qUWp1{font-family:"Lufga-Regular";font-weight:400;font-size:var(--font-size-p3, 10px);line-height:var(--line-height-p3, 14px);letter-spacing:.02em;margin-block-start:4px;padding-inline:4px;color:#696992}.qUWp1.MlfXW{color:#dd4c4c}.uOsW5{inline-size:100%}.XqkTH{max-block-size:308px;overflow-y:auto;background:#fff;border:1px solid #d4d4e0;border-radius:12px;box-shadow:0px 4px 24px rgba(40,40,99,.12);padding:4px;box-sizing:border-box}.XqkTH.E9YJD{border:0;border-radius:0;box-shadow:none;padding-inline:0}.JuppJ{display:flex;align-items:center;inline-size:100%;block-size:40px;padding:8px 16px;box-sizing:border-box;border:none;border-radius:8px;background:none;cursor:pointer;color:#696992;font-family:"Lufga-Regular";font-weight:400;font-size:var(--font-size-p1, 14px);line-height:var(--line-height-p1, 22px);letter-spacing:.015em}.JuppJ:hover{background:#f4f4f7;color:#282863}.JuppJ.AkUVd{font-family:"Lufga-Medium";font-weight:400;background:#f4f4f7;color:#282863}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple100": `#dad0fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"chartBlue": `#6a9ff0`,
	"chartPeach": `#fbd499`,
	"chartCyan": `#a9e5f2`,
	"chartPink": `#fda5ef`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"sh10": `0px 4px 12px rgba(40,40,99,.06)`,
	"sh20": `0px 4px 16px rgba(40,40,99,.08)`,
	"sh40": `0px 4px 24px rgba(40,40,99,.12)`,
	"sh60": `0px 4px 14px rgba(40,40,99,.24)`,
	"fontFamilyLight": `"Lufga-Regular"`,
	"fontFamilyNormal": `"Lufga-Medium"`,
	"fontFamilyBold": `"Lufga-SemiBold"`,
	"fontSizeH1": `var(--font-size-h1, 40px)`,
	"fontSizeH2": `var(--font-size-h2, 36px)`,
	"fontSizeH3": `var(--font-size-h3, 28px)`,
	"fontSizeH4": `var(--font-size-h4, 24px)`,
	"fontSizeH5": `var(--font-size-h5, 20px)`,
	"fontSizeH6": `var(--font-size-h6, 18px)`,
	"fontSizeP1": `var(--font-size-p1, 14px)`,
	"fontSizeP2": `var(--font-size-p2, 12px)`,
	"fontSizeP3": `var(--font-size-p3, 10px)`,
	"lineHeightH1": `var(--line-height-h1, 56px)`,
	"lineHeightH2": `var(--line-height-h2, 52px)`,
	"lineHeightH3": `var(--line-height-h3, 36px)`,
	"lineHeightH4": `var(--line-height-h4, 34px)`,
	"lineHeightH5": `var(--line-height-h5, 32px)`,
	"lineHeightH6": `var(--line-height-h6, 30px)`,
	"lineHeightP1": `var(--line-height-p1, 22px)`,
	"lineHeightP2": `var(--line-height-p2, 16px)`,
	"lineHeightP3": `var(--line-height-p3, 14px)`,
	"root": `XrOdD`,
	"inlineLabel": `H3n_a`,
	"field": `XDqyo`,
	"fieldError": `Cod_o`,
	"toggle": `xYZC4`,
	"message": `qUWp1`,
	"messageError": `MlfXW`,
	"popper": `uOsW5`,
	"list": `XqkTH`,
	"listInline": `E9YJD`,
	"slot": `JuppJ`,
	"slotSelected": `AkUVd`
};
export default ___CSS_LOADER_EXPORT___;
